import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/reports/customer-wise-revenue/-components/component";
import { SearchParams } from "./-data/model";

export const Route = createFileRoute("/(pharma)/_layout/reports/customer-wise-revenue/")({
  component: Component,
  validateSearch: SearchParams,
});